import type { CSSProperties } from 'react';

interface LoadingSpinnerProps {
  fullScreen?: boolean;
}

function LoadingSpinner({ fullScreen = false }: LoadingSpinnerProps) {
  return (
    <div className={`loading-spinner ${fullScreen ? 'full-screen' : ''}`}>
      <div className="spinner" />
      {fullScreen && (
        <p style={styles.branding}>Sentinel</p>
      )}
    </div>
  );
}

const styles: Record<string, CSSProperties> = {
  branding: {
    margin: '1rem 0 0 0',
    fontSize: 'var(--text-sm)',
    color: 'var(--color-text-light)',
    letterSpacing: '0.1em',
    textTransform: 'uppercase',
  },
};

export default LoadingSpinner;
